var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.mi_user.app_movil)?_c('DashGeneral'):_c('HomeMovil')],1)}
var staticRenderFns = []

export { render, staticRenderFns }